export const SHIPPING_CARRIER = {
     UNKNOWN: 'UNKNOWN',
     FEDEX: 'FEDEX',
     USPS: 'USPS',
     UPS: 'UPS',
     DHL: 'DHL',
};

export const SHIPPING_STATUS = {
     NOT_SHIPPED: 'NOT_SHIPPED',
     SHIPPED: 'SHIPPED',
     DRAFT: 'DRAFT',
};

export const SHIPMENT_CATEGORY = {
     GENERAL: 'general',
     SOW: 'sow',
};
